import Vue from 'vue'
import Axios from 'axios'
import ApiConnector from './services/api-connector'
import IconService from './services/icon-service'
import { translate } from '../util/translator';

const assetsPath = document.head.querySelector('meta[name=assets_uri]')
if (!assetsPath) {
  console.error('Map assets path not found')
}

const apiPath = document.head.querySelector('meta[name=api_uri]')
if (!apiPath) {
  console.error('API path not found')
}

const garagePath = document.head.querySelector('meta[name=garage_uri]')
if (!garagePath) {
  console.error('Garage path not found')
}

const termsPath = document.head.querySelector('meta[name=terms_uri]')
if (!termsPath) {
  console.error('Terms path not found')
  window.termsPath = '#'
} else {
  window.termsPath = termsPath.content
}

const privacyPath = document.head.querySelector('meta[name=privacy_uri]')
if (!privacyPath) {
  console.error('Privacy path not found')
  window.privacyPath = '#'
} else {
  window.privacyPath = privacyPath.content
}

window.garagePath = garagePath.content

Vue.prototype.$locale = document.documentElement.lang
Vue.prototype.$isApp = window.innerWidth < 768
Vue.prototype.$isTouch = 'ontouchstart' in window
Vue.prototype.$api = ApiConnector.getInstance(apiPath ? apiPath.content : null, Axios)
Vue.prototype.$icon = IconService.getInstance(assetsPath ? assetsPath.content : null).resolver
Vue.prototype.$translate = translate;

window.Vue = Vue
window.EventBus = new Vue()

window.addEventListener('resize', () => {
  window.Vue.prototype.$isApp = window.innerWidth < 768
  window.EventBus.$emit('resize')
})
